import { render } from 'react-dom';
import App from './App';
import '@mapado/makeup/styles/index.css';
import '@mapado/js-component/index.css';
import './style.css';

render(<App />, document.getElementById('demo'));
